export default __webpack_public_path__ + "static/media/BG10.ba8391fb.jpg";